;(function () {
  let controller = null

  const SECTION = 'mainCollection'
  const EVENTS = {
    pagination: 'mainCollection:pagination',
    facetRemoval: 'mainCollection:facetRemoval',
    render: 'mainCollection:renderUpdate',
    postRender: 'mainCollection:postRenderUpdate',
  }

  const setPageUpdate = ({ requestURL }) => {
    window.history.pushState({}, '', requestURL)

    SAXX.App.emit(SAXX.Events.CollectionFilterEvent, null, {
      section: SECTION,
    })

    mainCollectionUrlEvent({ requestURL })
  }

  const mainCollectionUrlEvent = (
    { requestURL = new URL(window.location), requestType = null } = {
      requestURL: new URL(window.location),
      requestType: null,
    },
  ) => {
    if (controller) {
      controller.abort()
    }

    requestURL.searchParams.set('section_id', 'main-collection')

    controller = new AbortController()
    const signal = controller.signal

    document
      .querySelector('#main-collection--product-list')
      .classList.add('loading')

    fetch(requestURL.toString(), { signal })
      .then((res) => res.text())
      .then((response) => {
        const section = new DOMParser().parseFromString(response, 'text/html')

        requestURL.searchParams.delete('section_id')

        SAXX.App.emit(EVENTS.render, null, {
          heading: section.querySelector(
            '#main-collection--interaction-heading',
          ).innerHTML,
          productList: section.querySelector('#main-collection--product-list')
            .innerHTML,
          page: Number(
            section
              .querySelector('#main-collection--product-list')
              .getAttribute('data-current-page'),
          ),
          previous: section.querySelector(
            '.main-collection--pagination.previous',
          ),
          next: section.querySelector('.main-collection--pagination.next'),
          requestType,
          url: requestURL,
        })

        controller = null
        SAXX.App.mount()
      })
      .catch((e) => {
        if (e.name === 'AbortError') return
        document
          .querySelector('#main-collection--product-list')
          .classList.remove('loading')
        console.error(e)
      })
  }

  const productList = document.getElementById('main-collection--product-list')
  const contentTiles = Array.from(
    document.querySelectorAll('template[class="content-tile--template"]'),
  ).map((tile) => {
    const segments =
      tile.getAttribute('data-raw-segments') !== '[]' ?
        JSON.parse(tile.getAttribute('data-raw-segments'))
      : ['?']
    return {
      segments: segments.map((segment) => new URLSearchParams(segment.trim())),
      position: Number(tile.getAttribute('data-position')),
      allFilters: JSON.parse(tile.getAttribute('data-all-filters')),
      markup: tile,
    }
  })

  // Updated the activateContentTiles function to ensure tiles are only shown in unfiltered views
  const activateContentTiles = (url = new URL(window.location)) => {
    let searchParamKey = 'page'
    for (const key of url.searchParams.keys()) {
      if (key.startsWith('page')) {
        searchParamKey = key
        break
      }
    }

    const tiles = contentTiles
    const currentPage = Number(url.searchParams.get(searchParamKey)) || 1
    const start = (currentPage - 1) * 24 + 1
    const end = currentPage * 24

    // Remove unnecessary filters that are not relevant for content tiles display
    for (const [key, value] of Array.from(url.searchParams)) {
      if (!key.includes('filter') || key.includes('availability')) {
        url.searchParams.delete(key, value)
      }
    }

    tiles
      .filter(({ segments, position, allFilters }) => {
        if (position < start || position > end) return false
        if (allFilters) return true

        const pageUrlSegments = Array.from(url.searchParams)
        return segments.some((segment) => {
          const segmentArray = Array.from(segment)
          if (segmentArray.length === 0 && pageUrlSegments.length === 0) {
            return true
          }

          if (segmentArray.length !== pageUrlSegments.length) return false

          const testParams = new URLSearchParams(url.searchParams)
          for (const [key, value] of segmentArray) {
            testParams.delete(key, value)
          }

          return Array.from(testParams).length === 0
        })
      })
      .forEach(({ position, markup }) => {
        const targets = Array.from(
          productList.querySelectorAll('.product-card-loaded'),
        )

        if (!targets[position - 1]) return

        productList.insertBefore(
          markup.content.cloneNode(true),
          targets[position - 1],
        )
      })
  }

  if (
    !document
      .getElementById('main-collection--product-list')
      .classList.contains('.combined-listings-view')
  ) {
    activateContentTiles()
  }

  const components = {
    mainCollection: SAXX.Init.Component((node, ctx) => {
      ctx.on(SAXX.Events.CollectionFilterEvent, (_, details) => {
        if (details.section !== SECTION) mainCollectionUrlEvent()
      })

      ctx.on(EVENTS.postRender, (_, details) => {
        const handles = JSON.parse(node.getAttribute('data-featured-items'))
        const productCards = node.querySelectorAll('.product-card-loaded')
        if (productCards && handles) {
          productCards.forEach((card) => {
            const handle = card.getAttribute('data-product-handle')
            if (handles.includes(handle)) {
              card.classList.add('featured-product-card')
            }
          })
        }

        if (window.nostojs) {
          window.nostojs((api) =>
            api.createRecommendationRequest().setElements(['plp-badge']).load(),
          )
        }
      })

      window.addEventListener('popstate', () => {
        mainCollectionUrlEvent()
      })
    }),
    mainCollectionContentTiles: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.postRender, (_, { url }) => {
        activateContentTiles(url)
      })
    }),
    mainCollectionPreviousPagination: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', (e) => {
        e.preventDefault()
        const requestURL = new URL(node.href)
        requestURL.searchParams.sort()

        window.history.pushState({}, '', requestURL)

        mainCollectionUrlEvent({
          requestURL,
          requestType: 'paginate',
        })
      })

      ctx.on(EVENTS.render, (_, details) => {
        if (details.requestType === 'paginate') {
          const currentValue = Number(
            node.getAttribute('data-pagination-value'),
          )
          const previousValue = Number(
            details.previous.getAttribute('data-pagination-value'),
          )
          if (previousValue < currentValue) {
            node.replaceWith(details.previous)
          }
          return
        }

        node.replaceWith(details.previous)
      })
    }),
    mainCollectionNextPagination: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', (e) => {
        e.preventDefault()
        const requestURL = new URL(node.href)
        requestURL.searchParams.sort()

        window.history.pushState({}, '', requestURL)

        mainCollectionUrlEvent({
          requestURL,
          requestType: 'paginate',
        })
      })

      ctx.on(EVENTS.render, (_, details) => {
        if (details.requestType === 'paginate') {
          const currentValue = Number(
            node.getAttribute('data-pagination-value'),
          )
          const nextValue = Number(
            details.next.getAttribute('data-pagination-value'),
          )
          if (nextValue > currentValue) {
            node.replaceWith(details.next)
          }
        }

        node.replaceWith(details.next)
      })
    }),
    mainCollectionProductList: SAXX.Init.Component((node, ctx) => {
      ctx.on(SAXX.Events.CollectionFilterEvent, () => {
        node.classList.add('loading')
      })

      ctx.on(EVENTS.render, (_, details) => {
        if (details.requestType === 'paginate') {
          const currentPage = Number(node.getAttribute('data-current-page'))
          node.setAttribute('data-current-page', details.page)

          const setInsertPoint =
            currentPage > details.page ? 'afterbegin' : 'beforeend'
          node.insertAdjacentHTML(setInsertPoint, details.productList)
          node.classList.remove('loading')

          ctx.emit(EVENTS.postRender, null, details)
          return
        }

        node.innerHTML = details.productList
        node.classList.remove('loading')

        ctx.emit(EVENTS.postRender, null, details)
      })

      node.addEventListener(
        'animate',
        () => {
          node
            .querySelector('.product-card-loaded .full-card--image-carousel')
            ?.classList.add('intro-animation')
        },
        { once: true },
      )

      if (node.classList.contains('combined-card-list')) {
        mainCollectionUrlEvent()
        ctx.on(EVENTS.postRender, () => {
          node.dispatchEvent(new Event('animate'))
        })
      } else {
        node.dispatchEvent(new Event('animate'))
      }
    }),
    mainCollectionInteractionHeading: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.render, (_, details) => {
        node.innerHTML = details.heading
      })
    }),
    mainCollectionFacet: SAXX.Init.Component((node) => {
      node.addEventListener('click', (e) => {
        e.preventDefault()
        const requestURL = new URL(node.href)
        setPageUpdate({ requestURL })
      })
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
